import { Type } from 'lucide-react';
import ElementSetting from '@/components/sections/builder/elements/footer/footer/sections/text-with-icon/setting';
import ElementContent, {
  defaultData,
} from '@/components/sections/builder/elements/footer/footer/sections/text-with-icon/content';

export const ElementPreviewIcon = Type;

const FooterSectionTextWithIcon = {
  type: 'footer_section_text_with_icon',
  group: 'footer_section',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defautlChilds: [],
  childs: [],
};

export default FooterSectionTextWithIcon;
